import { Component } from 'react';
import PropTypes from 'prop-types';
import { __, sprintf } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';
import FormSelect, { formOptions } from 'Components/FormSelect';
import { ContrastChecker, PanelColorSettings } from '@wordpress/editor';
import Select from 'Components/Select';
import Label from 'Components/Label';
import Text from 'Components/Text';
import { onChangeSelectCB, getCurrentSelected } from 'Utils/helpers';

/* eslint-disable react/no-danger */

const popupPositions = [
	{
		label: __('Right', 'ipt_fsqm'),
		value: 'r',
	},
	{
		label: __('Bottom Right', 'ipt_fsqm'),
		value: 'br',
	},
	{
		label: __('Bottom Center', 'ipt_fsqm'),
		value: 'bc',
	},
	{
		label: __('Bottom Left', 'ipt_fsqm'),
		value: 'bl',
	},
	{
		label: __('Left', 'ipt_fsqm'),
		value: 'l',
	},
	{
		label: __('Hidden / Manual Trigger'),
		value: 'h',
	},
];

const buttonStyles = [
	{
		label: __('Rectangular', 'ipt_fsqm'),
		value: 'rect',
	},
	{
		label: __('Circular', 'ipt_fsqm'),
		value: 'circ',
	},
];

export default class Popup extends Component {
	static propTypes = {
		setAttributes: PropTypes.func.isRequired,
		attributes: PropTypes.shape({
			form_id: PropTypes.string.isRequired,
			pos: PropTypes.string.isRequired,
			style: PropTypes.string.isRequired,
			header: PropTypes.string.isRequired,
			subtitle: PropTypes.string.isRequired,
			icon: PropTypes.string.isRequired,
			width: PropTypes.string.isRequired,
			color: PropTypes.string.isRequired,
			bgcolor: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}).isRequired,
		className: PropTypes.string,
	};

	static defaultProps = {
		className: null,
	};

	handleInput = event => {
		const { target } = event;
		const { name, value } = target;
		const { setAttributes } = this.props;

		setAttributes({
			[name]: value,
		});
	};

	render() {
		const {
			attributes: {
				form_id,
				pos,
				style,
				header,
				subtitle,
				icon,
				width,
				color,
				bgcolor,
				label,
			},
			setAttributes,
			className,
		} = this.props;

		const selectedForm = getCurrentSelected(formOptions, form_id);

		const title =
			__('Popup Form : ', 'ipt_fsqm') +
			(selectedForm
				? selectedForm.label
				: __('Please select a form', 'ipt_fsqm'));
		const message = __('Insert popup form in the page.', 'ipt_fsqm');

		return (
			<Placeholder className={className} title={title} message={message}>
				<FormSelect
					onChange={onChangeSelectCB('form_id', setAttributes)}
					value={selectedForm}
				/>
				<Label
					title={__('Button Position', 'ipt_fsqm')}
					description={__(
						'Select manual/hidden to create a trigger button yourself',
						'ipt_fsqm'
					)}
				>
					<Select
						options={popupPositions}
						onChange={onChangeSelectCB('pos', setAttributes)}
						value={getCurrentSelected(popupPositions, pos)}
					/>
				</Label>
				{pos !== 'h' ? (
					<Label title={__('Button Text', 'ipt_fsqm')}>
						<Text
							name="label"
							value={label}
							onChange={this.handleInput}
						/>
					</Label>
				) : (
					<Label title={__('Trigger Code', 'ipt_fsqm')}>
						<div className="eform-gtb-explanation">
							<p
								dangerouslySetInnerHTML={{
									__html: sprintf(
										__(
											'Insert any anchor tag with href set to <code>%s</code>.',
											'ipt_fsqm'
										),
										`#ipt-fsqm-popup-form-${form_id}`
									),
								}}
							/>
							<pre style={{ overflow: 'auto', maxWidth: '100%' }}>
								{`<a href="#ipt-fsqm-popup-form-3">${__(
									'Popup Form',
									'ipt_fsqm'
								)}</a>`}
							</pre>
						</div>
					</Label>
				)}
				<Label title={__('Button Style', 'ipt_fsqm')}>
					<Select
						options={buttonStyles}
						onChange={this.handleInput}
						value={getCurrentSelected(buttonStyles, style)}
					/>
				</Label>
				<Label
					title={__('Popup Header Title', 'ipt_fsqm')}
					description={__('%FORM% is form name', 'ipt_fsqm')}
				>
					<Text
						name="header"
						value={header}
						onChange={this.handleInput}
					/>
				</Label>
				<Label title={__('Popup Header Subtitle', 'ipt_fsqm')}>
					<Text
						name="subtitle"
						value={subtitle}
						onChange={this.handleInput}
					/>
				</Label>
				<Label
					title={__('Popup Header Icon', 'ipt_fsqm')}
					description={__(
						'CSS Class for icons, provided by your theme or some other plugin.',
						'ipt_fsqm'
					)}
				>
					<Text
						name="icon"
						value={icon}
						onChange={this.handleInput}
					/>
				</Label>
				<Label title={__('Initial Popup width', 'ipt_fsqm')}>
					<Text
						name="width"
						value={width}
						onChange={this.handleInput}
					/>
				</Label>
				<Label panel>
					<PanelColorSettings
						title={__('Button Color', 'ipt_fsqm')}
						colorSettings={[
							{
								value: bgcolor,
								onChange: c => setAttributes({ bgcolor: c }),
								label: __('Background Color', 'ipt_fsqm'),
							},
							{
								value: color,
								onChange: c => setAttributes({ color: c }),
								label: __('Text Color', 'ipt_fsqm'),
							},
						]}
					>
						<ContrastChecker
							{...{
								isLargeText: true,
								textColor: color,
								backgroundColor: bgcolor,
							}}
						/>
					</PanelColorSettings>
				</Label>
			</Placeholder>
		);
	}
}
